import axios from './axios'
import baseUrl from './pubilshSet'
export default {
  timer: undefined,
  commonPageSize: 30,
  canUpLoadFileList: ['pdf', 'msg', 'xlsx', 'docx', 'jpg', 'xls', '7z', 'pptx', 'txt', 'ppt', 'bmp', 'png', 'tif', 'jpeg', 'rar', 'zip'],
  excelUpLoadFileList: ['xlsx', 'xls'],
  videoUpLoadFileList: ['mp4'],
  imgUpLoadFileList: ['jpg', 'png', 'jpeg', 'bmp', 'gif'],
  loginOut (url) {
    window.localStorage.removeItem('baigangToken')
    window.localStorage.removeItem('memberId')
    if (!url) {
      return window.location.reload()
    }
    window.location.href = baseUrl.userCenterHostUrl + url
    window.location.reload()
  },
  uploadFileNew (file) {
    let postFile = new FormData()
    postFile.append('file', file)
    var p = new Promise((resolve, reject) => {
      axios.post('/baigang/common/picStore/upload', postFile).then(msg => {
        resolve(msg.data)
      })
    })
    return p
  },
  returnSelType (type) {
    if (parseInt(type) === 1) {
      return '理计'
    }
    if (parseInt(type) === 2) {
      return '磅计'
    }
    if (parseInt(type) === 3) {
      return '理计/磅计'
    }
    return '错误，请重新上传'
  },
  alertTips (object) {
    let DOM = document.createElement('div')
    if (object.type === 'success') {
      DOM.className = 'allTips success'
    } else {
      DOM.className = 'allTips error'
    }
    // let html = `<span>${object.title}</span>: <span>${object.content}</span>`
    let html = `<span style="font-size: 16px">${object.content}</span>`
    DOM.innerHTML = html
    let tips = document.querySelectorAll('.allTips')
    if (tips[tips.length - 1] && tips[tips.length - 1].innerHTML.toString() === html) {
      console.log('tips[0].innerHTML.toString()', tips[0].innerHTML.toString())
      console.log('tips[0].innerHTML', tips[0].innerHTML)
      return
    }
    document.body.appendChild(DOM)
    if (tips.length < 1) {
      setTimeout(() => {
        DOM.style.top = '40px'
      }, 10)
      DOM.style.right = '45%'
    } else {
      setTimeout(() => {
        DOM.style.top = parseInt(tips[tips.length - 2].style.top.replace('px', ''), 0) + (tips[tips.length - 2].clientHeight + 12) + 'px'
      }, 10)
      DOM.style.right = '45%'
    }
    setTimeout(() => {
      DOM.style.right = '45%'
      setTimeout(() => {
        DOM.style.top = '-10%'
        setTimeout(() => {
          document.body.removeChild(DOM)
        }, 500)
      }, object.stayTime * 1000)
    }, 10)
  },
  returnQuery (url, object) {
    if (object) {
      let html = ''
      for (let i in object) {
        html += '&' + i + '=' + encodeURI(object[i])
      }
      html = html.substr(1, html.length - 1)
      return url + '?' + html
    }
  },
  uploadFile (file, filetype) {
    let postFile = new FormData()
    postFile.append('uploadedFile', file)
    var p = new Promise((resolve, reject) => {
      axios.post('/api/resource', postFile).then(msg => {
        resolve(msg.data)
      })
    })
    return p
  },
  getPoChangedFieldsList (urlHtml) {
    if (urlHtml) {
      var p = new Promise((resolve, reject) => {
        axios.get('/api/doc/vlookup?' + urlHtml).then(msg => {
          resolve(msg.data)
        })
      })
      return p
    } else {
      return []
    }
  },
  upSupportFile (file, url, fileTitle) {
    let postFile = new FormData()
    postFile.append(fileTitle, file)
    var p = new Promise((resolve, reject) => {
      axios.post(url, postFile).then(msg => {
        resolve(msg.data)
      })
    })
    return p
  },
  getImgUrl (fileId) {
    return baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + fileId
  },
  doubleComfirm (object) {
    let dom = document.createElement('div')
    dom.id = 'doubleConfirm'
    let html = `<div class="newTips">
      <div class="cover"  style="opacity: 1"></div>
      <div id="newTipsBody2" class="newTipsBody">
        <ul>
          <li class="d_f" style="justify-content: space-between;align-items: center"><span style="display:inline-block;width: 95%" class="font20">${window.localStorage.getItem('language') === 'en-US' ? 'Prompt' : '提示'}</span><i id="cancelButtom2" class="icon iconfont iconguanbi" style="font-size: 25px"></i></li>
          <li class="t_c font24"><i class="icon iconfont icongantan m_r_10" style="font-size: 25px;color: #C73343"></i><span>${object.content}</span></li>
          <li class="t_c">
            <button id="cancelButtom1" class="cancelButton m_l_10 m_r_10" >${window.localStorage.getItem('language') === 'en-US' ? 'NO' : '取消'}</button>
            <button id="confirmButtom1" class="redButton m_r_10 m_l_10" >${window.localStorage.getItem('language') === 'en-US' ? 'Yes' : '确定'}</button>
          </li>
        </ul>
      </div>
    </div>`
    dom.innerHTML = html
    document.body.appendChild(dom)
    setTimeout(function () {
      document.getElementById('newTipsBody2').style.opacity = '1'
      document.getElementById('newTipsBody2').style.top = '-30px'
    }, 10)
    let confirmButtom1 = document.getElementById('confirmButtom1')
    if (confirmButtom1) {
      confirmButtom1.onclick = function (e) {
        object.successFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom1 = document.getElementById('cancelButtom1')
    if (cancelButtom1) {
      cancelButtom1.onclick = function (e) {
        object.errorFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
    let cancelButtom2 = document.getElementById('cancelButtom2')
    if (cancelButtom2) {
      cancelButtom2.onclick = function (e) {
        object.errorFun(e)
        document.getElementById('newTipsBody2').style.opacity = '0'
        document.getElementById('newTipsBody2').style.top = '-100px'
        setTimeout(function () {
          document.body.removeChild(document.getElementById('doubleConfirm'))
        }, 300)
      }
    }
  },

  // 时间格式
  returnDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      let newDate = new Date(date.replace(/-/g, '/'))
      let year = newDate.getFullYear()
      let month = newDate.getMonth() + 1
      let Todate = newDate.getDate()
      let hour = newDate.getHours()
      let min = newDate.getMinutes()
      let sec = newDate.getSeconds()
      let zhYear = window.localStorage.getItem('language') === 'en-US' ? '/' : '年'
      let zhMouth = window.localStorage.getItem('language') === 'en-US' ? '/' : '月'
      let zhDate = window.localStorage.getItem('language') === 'en-US' ? ' ' : '日'
      month = month < 10 ? '0' + month : month
      Todate = Todate < 10 ? '0' + Todate : Todate
      hour = hour < 10 ? '0' + hour : hour
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      if (type === 'YYMMDDHHMMSS') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min + ':' + sec
      } else if (type === 'YYMMDD') {
        return year + '/' + month + '/' + Todate
      } else if (type === 'YYMMDDHHMM') {
        return year + '/' + month + '/' + Todate + ' ' + hour + ':' + min
      } else if (type === 'YYMMDDZH') {
        return year + zhYear + month + zhMouth + Todate + zhDate
      } else if (type === 'YYMMDDheng') {
        return year + '-' + month + '-' + Todate
      }
    }
  },
  returnNewDate (date, type) {
    if (date === null || date === '' || date === undefined) {
      return ''
    } else {
      if (type === 'YYMMDD') {
        return date.split(' ')[0]
      } else {
        return date.split('.')[0].replace('T', ' ')
      }
    }
  },
  todayDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
  checkIfEmpty (data, list, value) {
    let content = window.localStorage.getItem('language') === 'en-US' ? 'Please check the required fields' : '请检查必填项!'
    if (value) {
      content = value
    }
    for (let i in data) {
      if (list.indexOf(i) >= 0 && !data[i]) {
        this.alertTips({
          type: 'error',
          title: '提示',
          content: content,
          stayTime: 5
        })
        return true
      }
    }
    return false
  },
  numFixed (num, fixedNum) {
    if (num !== null && num !== undefined && num !== '') {
      let newFixedNum = fixedNum || 0
      if (fixedNum) {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{2,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      } else {
        return (parseFloat(num).toFixed(newFixedNum) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      }
    } else {
      return 0
    }
  },
  // returnActivityHasOccurred (type) {
  //   if (type === true) {
  //     return 'Yes'
  //   } else if (type === false) {
  //     return 'No'
  //   } else {
  //     return type
  //   }
  // },
  // datafixBoolean (data, list) {
  //   for (let i in data) {
  //     if (list.indexOf(i) >= 0) {
  //       if (data[i] === 'true' || data[i] === true) {
  //         data[i] = true
  //       } else if (data[i] === 'false' || data[i] === false) {
  //         data[i] = false
  //       }
  //     }
  //   }
  // },
  // datafixNumber (data, list, fixedNum) {
  //   for (let i in data) {
  //     if (list.indexOf(i) >= 0) {
  //       if (fixedNum) {
  //         data[i] = data[i] ? parseFloat(parseFloat(data[i]).toFixed(2)) : 0
  //       } else {
  //         data[i] = data[i] ? parseInt(data[i]) : 0
  //       }
  //     }
  //   }
  // },
  // 数组去重
  // conbinedistinct (list1, list2, name) {
  //   for (let i = 0; i < list1.length; i++) {
  //     for (let j = 0; j < list2.length; j++) {
  //       if (list1[i][name] === list2[j][name]) {
  //         list2.splice(j, 1)
  //         j--
  //       }
  //     }
  //   }
  //   let newList = list1.concat(list2)
  //   return newList
  // },
  // returnDigit (type, name, content) {
  //   if (name === '1') {
  //     let reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
  //     if (!reg.test(type)) {
  //       this.alertTips({
  //         type: 'error',
  //         title: '错误:',
  //         content: content,
  //         stayTime: 5
  //       })
  //       return true
  //     }
  //   } else if (name === '2') {
  //     let freg = /^\d+(\.\d+)?$/
  //     if (!freg.test(type)) {
  //       this.alertTips({
  //         type: 'error',
  //         title: '错误',
  //         content: content,
  //         stayTime: 5
  //       })
  //       return true
  //     }
  //   } else {
  //     let freg = /^[1-9]\d*$/
  //     if (!freg.test(type)) {
  //       this.alertTips({
  //         type: 'error',
  //         title: '错误',
  //         content: content,
  //         stayTime: 5
  //       })
  //       return true
  //     }
  //   }
  //   return false
  // },
  // 隐藏手机号 隐藏身份证
  returnHide (type, num) {
    if (type) {
      if (num === 'phone') {
        let reg = /^(\d{3})\d{4}(\d{4})$/
        return type.replace(reg, '$1****$2')
      } else if (num === 'IdCard') {
        let reg = /^(\d{6})\d{8}(\d{4})$/
        return type.replace(reg, '$1********$2')
      }
    }
  },
  async asyncReturnIsBishiTime () {
    // 闭市检测
    let res = await axios.get('/baigang/app/home/queryServiceTime/?accountId=1')
    let currDate = new Date()
    let endDate = res.data.endTime
    let startrDate = res.data.startTime
    let dateStr = `${currDate.getFullYear()}-${currDate.getMonth() + 1}-${currDate.getDate()}`

    let currTimestamp = currDate.getTime()
    let endTimestamp = new Date(`${dateStr} ${endDate}`).getTime()
    let startTimestamp = new Date(`${dateStr} ${startrDate}`).getTime()

    if (currTimestamp > endTimestamp || currTimestamp < startTimestamp) {
      return true
    } else {
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js